import React, { Component } from "react";
import BazarCard from "./BazarCard";

class OpenBazarGrid extends Component {
  getMobileDivs = data => {
    return data.map((rec, index) => {
      //console.log(JSON.stringify(rec));
      return (
        <div
          style={{
            marginLeft: "5px",
            marginRight: "5px"
          }}
        >
          <BazarCard
            key={rec.key}
            data={rec}
            index={index}
            phoneNumber={this.props.phoneNumber}
            handleEdit={this.props.handleEdit}
            tableName={this.props.tableName}
            firebase={this.props.firebase}
            updateRecord={this.props.updateRecord}
            onNotifyUsers={this.props.onNotifyUsers}
            allSuppliers={this.props.allSuppliers}
            path={this.props.tableName}
          />
        </div>
      );
    });
  };

  render() {
    if (
      this.props.data &&
      this.props.data !== undefined &&
      this.props.data.length > 0
    ) {
      return (
        <div>
          {this.getMobileDivs(this.props.data)}
          <div style={{ height: "400px" }}></div>
        </div>
      );

      //return this.getRows(this.props.data);
    } else {
      if (this.props.dataIsLoaded) {
        return (
          <div>
            <div
              style={{
                textAlign: "center"
              }}
            >
              No posts currently availably in Open Bazar, tap Add Posts to
              create one.
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              margin: "15px"
            }}
          >
            <div
              style={{
                textAlign: "center"
              }}
            >
              Seems like you are on a slow network, we are loading data please
              wait a moment...
            </div>

            <div
              style={{
                backgroundColor: "whtie",
                height: "200px"
              }}
            ></div>
          </div>
        );
      }
    }
  }
}

export default OpenBazarGrid;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/OpenBazarGrid.jsx